import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const G72Land = Loadable(lazy(() => import("./G72Land")));
const G72Apply = Loadable(lazy(() => import("./G72Apply")));
const pathExt = getPathByCdExt(EXAM_TYPES.G72.rid_cd_ext);

const route = [
  { path: `/pub/${pathExt}/land/:rid_cd_ext/:rid_imp_sr`, element: <G72Land /> },
  { path: `/pub/${pathExt}/apply/:rid_cd_ext/:rid_imp_sr`, element: <G72Apply /> }
];
export default route;